
// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";

// Material Dashboard 2 React components
import MDBox from "../../MDBox";
import MDTypography from "../../MDTypography";
import MDButton from "../../MDButton";
import { Grid } from "@mui/material";

function FieldsCard({
  color,
  title,
  description,
  rowNumber,
  deleteButton,
  editButton,
}: any) {
  return (
    <Card sx={{ height: "100%" }}>
      <MDBox display="flex" pt={1} px={2}>
        <MDBox
          variant="gradient"
          bgColor={color}
          color={color === "light" ? "dark" : "white"}
          coloredShadow={color}
          borderRadius="xl"
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="4rem"
          height="4rem"
          mt={-4}
        >
          {rowNumber}
        </MDBox>
        <MDBox textAlign="right" lineHeight={1.25}>
          <MDTypography variant="h5" fontWeight="light" color="dark" ml={1}>
            {title}
          </MDTypography>
        </MDBox>
      </MDBox>
      <Divider />

      <MDBox sx={{ flex: 1 }}>
        <MDTypography fontSize={12} align={"center"} ml={1} color="secondary">
          توضیحات :
        </MDTypography>
        {description.length < 1 && (
          <>
            <MDTypography
              fontSize={12}
              align={"center"}
              ml={1}
              color="secondary"
            >
              ---------
            </MDTypography>
          </>
        )}
        <MDTypography variant="h6" ml={1}>
          {description}
        </MDTypography>
      </MDBox>
      <Divider />
      <MDBox pb={2} px={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12} lg={6}>
            <MDBox>{editButton}</MDBox>
          </Grid>
          <Grid item xs={12} md={12} lg={6}>
            <MDBox>{deleteButton}</MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}

// Setting default values for the props of ComplexStatisticsCard
FieldsCard.defaultProps = {
  color: "info",
};
// Typechecking props for the ComplexStatisticsCard
FieldsCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  title: PropTypes.string.isRequired,
  rowNumber: PropTypes.string,
  description: PropTypes.string,
  deleteButton: PropTypes.node,
  editButton: PropTypes.node,
};

export default FieldsCard;
